import React, { forwardRef } from "react";
import PropTypes from "prop-types";
import { Box, Button } from "@edreamsodigeo/prisma-design-system";
const FormSwitcherButton = /*#__PURE__*/forwardRef(({
  label,
  onClick
}, ref) => /*#__PURE__*/React.createElement(Box, {
  mt: "big",
  mb: "3x_big",
  sx: {
    display: "flex",
    justifyContent: "center"
  }
}, /*#__PURE__*/React.createElement(Button, {
  type: "secondary",
  onClick: onClick,
  ref: ref
}, label)));
FormSwitcherButton.propTypes = {
  label: PropTypes.node.isRequired,
  onClick: PropTypes.func.isRequired
};
export default FormSwitcherButton;